//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        allowedSchoolNumbers: Array,
        playThroughDefault: Boolean,
        states: Object
    },

    data () {
        return {
            dialogVisible: false,
            buttonLoading: false,
            formSending: false,
            form: {},
            formErrors: {},
            defaultForm: {
                id: null,
                testclass: false,
                school: '',
                state: '',
                name: '',
                start: '',
                users: 0,
                play_through: this.playThroughDefault
            },
            pickerOptions: {
                firstDayOfWeek: 1,
                disabledDate: this.checkDisabledDate
            },
            loading: false,
            availableDates: []
        };
    },

    computed: {
        formMethod () {
            return this.form.id === null ? 'post' : 'put';
        },

        formUrl () {
            return 'classrooms' + (this.form.id !== null ? '/' + this.form.id : '');
        }
    },

    mounted () {
        this.form = _.clone(this.defaultForm);
    },

    methods: {
        setItem (item) {
            if (!item) {
                this.form = _.clone(this.defaultForm);
            } else {
                this.form = {
                    id: item.id,
                    testclass: item.testclass,
                    school: item.school,
                    name: item.name,
                    start: moment(item.start).format('YYYY-MM-DD'),
                    play_through: item.play_through
                };
            }
        },

        handleSave () {
            this.buttonLoading = true;

            axios({
                method: this.formMethod,
                url: this.formUrl,
                data: this.form
            }).then(response => {
                this.$message({
                    type: 'success',
                    message: response.data.message
                });
                this.$emit('form-saved');
                if (response.data && response.data.users && response.data.users.length) {
                    this.$emit('show-users', response.data.users);
                }
                this.buttonLoading = false;
                this.hide();
            }).catch(error => {
                if (error.response.status === 422) {
                    this.formErrors = error.response.data.errors;
                }
                this.buttonLoading = false;
            });
        },

        async show () {
            this.formErrors = {};
            this.dialogVisible = true;
            this.loadAvailableDates();
        },

        hide () {
            this.dialogVisible = false;
        },

        loadAvailableDates () {
            this.loading = true;

            axios.get('register/available-days').then(response => {
                this.availableDates = response.data.map(date => moment(date, 'YYYY-MM-DD').toDate().getTime());
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        checkDisabledDate (date) {
            return !this.availableDates.some(availableDate => availableDate === date.getTime());
        }
    }
};
